import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { LoadingState } from "@repo/app-types/client/client";
import type {
  CustomFieldDefinition,
  CustomFieldMetadata,
  CustomFieldProvider,
} from "@repo/app-types/entities/customField";
import { getAxiosInstanceWithAuth } from "../../api/axiosConfig.js";

export const customFieldDefinitionsAdapter =
  createEntityAdapter<CustomFieldDefinition>();

const initialState = customFieldDefinitionsAdapter.getInitialState<{
  status: LoadingState;
  error: string | null;
}>({
  status: LoadingState.LOADING,
  error: null,
});

export const setCustomFieldDefinitionsForProvider = createAsyncThunk<
  CustomFieldDefinition[],
  {
    provider: CustomFieldProvider;
    customFieldMetadatas: CustomFieldMetadata[];
  },
  { rejectValue: string }
>(
  "customFieldDefinitions/setCustomFieldDefinitionsForProvider",
  async ({ provider, customFieldMetadatas }, thunkAPI) => {
    try {
      const axios = await getAxiosInstanceWithAuth();
      const response = await axios.put(`/custom_fields/provider/${provider}`, {
        custom_field_metadatas: customFieldMetadatas,
      });

      return thunkAPI.fulfillWithValue(response.data);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

const customFieldDefinitionsSlice = createSlice({
  name: "customFieldDefinitions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        setCustomFieldDefinitionsForProvider.pending,
        (state, action) => {
          state.status = LoadingState.LOADING;
        },
      )
      .addCase(
        setCustomFieldDefinitionsForProvider.fulfilled,
        (state, action) => {
          state.status = LoadingState.LOADED;

          console.log("payload to upsert");
          console.log(action.payload);

          customFieldDefinitionsAdapter.upsertMany(state, action.payload);
        },
      )
      .addCase(
        setCustomFieldDefinitionsForProvider.rejected,
        (state, action) => {
          state.status = LoadingState.ERROR;
          state.error = action.error.message || null;
        },
      );
  },
});

export default customFieldDefinitionsSlice.reducer;
